import { motion } from "framer-motion";
import { TEAM } from "../lib/content";
import { EASE } from "./Reveal";

export const getInitials = (name) => {
  const words = name.replace(/[“”"]/g, "").split(" ").filter((w) => !["Jr.", "Sr.", "II", "III"].includes(w));
  const first = words[0]?.[0] || "";
  const last = words.length > 1 ? words[words.length - 1][0] : "";
  return (first + last).toUpperCase();
};

// Photo placeholder shown until real headshots are provided.
export const PhotoFrame = ({ member, className = "" }) => (
  <div className={`relative overflow-hidden bg-dst-navy ${className}`}>
    {member.img ? (
      <img src={member.img} alt={member.name} style={{ objectPosition: member.imgPos || "center" }} className="w-full h-full object-cover bg-dst-ink" />
    ) : (
      <div className="absolute inset-0 grid place-items-center bg-gradient-to-br from-dst-navy to-dst-ink">
        <div className="absolute inset-0 grain opacity-40" />
        <div className="relative text-center px-4">
          <div className="font-oswald font-700 text-7xl lg:text-8xl text-white/15 tracking-tight">
            {getInitials(member.name)}
          </div>
          <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-white/30">Photo Coming Soon</div>
        </div>
      </div>
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-dst-ink via-dst-ink/10 to-transparent pointer-events-none" />
    <div className="absolute top-4 left-4">
      <span className="bg-dst-red text-white text-[10px] sm:text-xs font-bold tracking-[0.18em] uppercase px-3 py-1.5">
        {member.role}
      </span>
    </div>
  </div>
);

export const TeamCards = () => (
  <div data-testid="team-cards" className="grid sm:grid-cols-2 gap-6 lg:gap-8">
    {TEAM.map((m, i) => (
      <motion.div
        key={m.name}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: EASE }}
        className="group"
        data-testid={`team-card-${i}`}
      >
        <PhotoFrame member={m} className="h-[380px] lg:h-[460px]" />
        <div className="relative -mt-16 px-6 pointer-events-none">
          <h3 className="font-oswald font-700 uppercase tracking-tight text-3xl lg:text-4xl text-white drop-shadow-lg">{m.name}</h3>
          <p className="text-dst-red font-oswald uppercase tracking-wide text-sm mt-1">{m.tagline}</p>
        </div>
      </motion.div>
    ))}
  </div>
);
